// https://www.gatsbyjs.org/docs/browser-apis/

// global styles
import "./src/styles/index.scss"

// gatsby-plugin-transitions
export const shouldUpdateScroll = () => {
  return false
}
